module.exports = __webpack_public_path__ + "img/logo.e7b4d0c6.png";